import React from 'react';
import loadScript from '../utils/loadScript';
loadScript('//s.alicdn.com/@at/t/a/font_4215189_flr488r7ide.js');
interface IconPropsType {
  className: string;
  width?: string;
  height?: string;
  onClick?: (e: any) => void;
  symbol:
    | 'icon-rating-star-fill'
    | 'icon-time-history'
    | 'icon-survey'
    | 'icon-industry-hardware-tools'
    | 'icon-order-success'
    | 'icon-product'
    | 'icon-share'
    | 'icon-coupon'
    | 'icon-logistics-land-transport'
    | 'icon-return'
    | 'icon-security'
    | 'icon-flag'
    | 'icon-email'
    | 'icon-info'
    | 'icon-success'
    | 'icon-down'
    | 'icon-play-fill'
    | 'icon-up'
    | 'icon-close'
    | 'icon-close-fill'
    | 'icon-cart-add'
    | 'icon-message-comments'
    | 'icon-follow'
    | 'icon-follow-fill'
    | 'icon-left'
    | 'icon-guaranteed-bg-graphics'
    | 'icon-right';
}
export default function DetailIcon(props: IconPropsType) {
  const { symbol, ...other } = props;
  return (
    <svg {...other}>
      <use xlinkHref={`#${symbol}`}></use>
    </svg>
  );
}
